import createOptions from "utils/createOptions";
import {creativesFormsObject} from "../CreativesConstants";

export default createOptions(creativesFormsObject);
